import type {
	BaseQueryApi,
	BaseQueryError,
	BaseQueryMeta,
	QueryReturnValue
} from '@reduxjs/toolkit/query'
import type { BaseQueryArg } from '@reduxjs/toolkit/query'
import type { AxiosBQ } from 'api/utils/rtk'

import { appSelectors } from '@appStore/reducers/app'
import store from '@appStore/store'

async function adaptPromiseForRTK(promise: Promise<any>) {
	try {
		const data = (await promise) ?? '' // to check `isSuccess` if promise return undefined
		return { data }
	} catch (error) {
		return { error }
	}
}

function shouldUseRegularFetch() {
	const globalState = store.getState()
	const isBackendAutomation = appSelectors.isBackendAutomation(globalState)

	return isBackendAutomation
}

const fetchViaExtensionConditional =
	<ResultType, QueryArg>(
		getParams: (arg: QueryArg) => BaseQueryArg<AxiosBQ> & {
			fetchWithConnector: () => Promise<any>
		}
	) =>
	(
		arg: QueryArg,
		_store: BaseQueryApi,
		_: any,
		baseQuery: (arg: BaseQueryArg<AxiosBQ>) => ReturnType<AxiosBQ>
	): Promise<
		QueryReturnValue<
			ResultType,
			BaseQueryError<AxiosBQ>,
			BaseQueryMeta<AxiosBQ>
		>
	> => {
		const { fetchWithConnector, ...params } = getParams(arg)

		return shouldUseRegularFetch()
			? // @ts-ignore always promise
				baseQuery(params)
			: adaptPromiseForRTK(fetchWithConnector())
	}

export {
	adaptPromiseForRTK,
	fetchViaExtensionConditional,
	shouldUseRegularFetch
}
